import { EntryHeader } from "@dreambigger/shared/src/types";

/** Merge an autoPopulate config's per-slot header overrides on top of the
 *  step-level resolved header. Unset slots fall through to the step level. */
export default function mergeEntryHeader(
  stepHeader: Required<EntryHeader>,
  overrides?: Partial<EntryHeader>
): Required<EntryHeader> {
  if (!overrides) return stepHeader;
  return {
    topline: overrides.topline ?? stepHeader.topline,
    title: overrides.title ?? stepHeader.title,
    titleAppend: overrides.titleAppend ?? stepHeader.titleAppend,
    subtitle: overrides.subtitle ?? stepHeader.subtitle,
    expandedTitle: overrides.expandedTitle ?? stepHeader.expandedTitle,
  };
}
